/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// TODO #4 Do budoucna je zde možnost dalších nastavení stretch.
// - https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit
/**
 * Číselník roztažení médií.
 * @enum {string}
 */
const StretchEnum = {
  /** Zobrazí celé médium uvnitř rámu. Zachová poměr stran. Může být zobrazeno černé pozadí. */
  CONTAIN: 'CONTAIN',
  /** Vyplní celý rám médiem. Zachová poměr stran. Může dojít k ořezu média. */
  COVER: 'COVER',
  /** Roztáhne médium na velikost rámu. Nezachová poměr stran. */
  FILL: 'FILL'
};

export default StretchEnum;
